export default "__VITE_ASSET__CFOKDi3k__"